import React from "react";
import { cn } from "@/lib/utils";

interface ChipListProps {
  items: { label: string; value: string; type: string }[];
  selectedItems: string[];
  onItemClick?: (item: { label: string; value: string; type: string }) => void;
  className?: string;
}

export function ChipList({
  items,
  selectedItems: initiallySelected,
  onItemClick,
  className,
}: ChipListProps) {
  const [selectedItems, setSelectedItems] = React.useState<Set<string>>(
    new Set(initiallySelected),
  );

  React.useEffect(() => {
    setSelectedItems(new Set(initiallySelected));
  }, [initiallySelected]);

  return (
    <div className={cn("flex flex-wrap items-center gap-2", className)}>
      {items.map((item) => {
        const isSelected = selectedItems.has(item.value);
        return (
          <button
            type="button"
            key={item.value}
            onClick={() => {
              onItemClick?.(item);
            }}
            className={cn(
              "inline-flex items-center rounded-md px-3 py-1.5 text-sm font-medium transition-all",
              "hover:scale-105 active:scale-95",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
              isSelected
                ? "bg-primary text-primary-foreground shadow-sm"
                : "bg-secondary text-secondary-foreground hover:bg-secondary/80",
            )}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
